import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import "./i18n";

import { AuthProvider, useAuth } from "./lib/auth";
import { initAnalytics, pageView } from "./lib/analytics";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Test from "./pages/Test";
import Result from "./pages/Result";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Onboarding from "./pages/Onboarding";
import Legal from "./pages/Legal";
import Knowledge from "./pages/Knowledge";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (!user) return <Navigate to={`/auth?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return children;
}

function Analytics() {
  const loc = useLocation();
  useEffect(() => { initAnalytics(); }, []);
  useEffect(() => { pageView(loc.pathname); window.scrollTo(0, 0); }, [loc.pathname]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Analytics />
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/bharatiq" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:category" element={<Shop />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/knowledge" element={<Knowledge />} />
          <Route path="/privacy" element={<Legal page="privacy" />} />
          <Route path="/terms" element={<Legal page="terms" />} />
          <Route path="/refund" element={<Legal page="refund" />} />
          <Route path="/contact" element={<Legal page="contact" />} />
          <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
          <Route path="/test" element={<Protected><Test /></Protected>} />
          <Route path="/result/:sessionId" element={<Protected><Result /></Protected>} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/admin" element={<Protected><Admin /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
